import customerInstance from '../instance'

const getDeliveryTypeConfig = () => {
	return customerInstance.get('/deliveryTypeConfigs')
}

export default getDeliveryTypeConfig
